module.exports = {"result":"Search Result","group":"Group ID","transaction":"Transaction ID","invoice":"Invoice","profit":"Profit","debt":"Debt","credit":"Credit","sellPrice":"Sell Price","baseFare":"Base Fare","customerName":"Customer Name","ticketedTime":"Ticketed Time","startDate":"Start Date","endDate":"End Date","clear":"CLEAR","finish":"FINISH","lock":"LOCK","paid":"PAID","payment_lock":"Pay Lock","salesName":"Sales"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/accounting/indivi/result.json
// module id = eXrF
// module chunks = 58